import WalletNotificationList from './WalletNotificationList';
import WalletNotificationShow from './WalletNotificationShow';

const walletNotifications = {
	show: WalletNotificationShow,
	list: WalletNotificationList
};

export default walletNotifications;
